import { useLocalStorageState } from './useLocalStorageState'

export const useFavoriteFilters = () => {
    const [favorites, setFavorites] = useLocalStorageState<{ [key: string]: boolean }>(
        'favorites',
        {},
    )

    const toggleFavorite = (filterId: string) => {
        if (favorites[filterId]) {
            delete favorites[filterId]
        } else {
            favorites[filterId] = true
        }
        setFavorites({ ...favorites })
    }

    return {
        favorites,
        setFavorites,
        toggleFavorite,
    }
}
